import type { EligibilityFormData } from '../types'
import type { EligibilityFieldErrors } from './types'

export function getMaxBirthDateForDatePicker() {
  const today = new Date()
  const year = today.getFullYear() - 18
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export function getBirthDateForNativePicker(value: string) {
  if (!value) return ''
  const [month, day, year] = value.split('/')
  if (!month || !day || !year || year.length !== 4) return ''
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

export function toStoredBirthDate(value: string) {
  if (!value) {
    return ''
  }

  const [year, month, day] = value.split('-')
  return `${month}/${day}/${year}`
}

export function isUnderageForEnrollment(value: string) {
  if (!value) return false
  const [month, day, year] = value.split('/')
  if (!month || !day || !year || year.length !== 4) return false

  const dob = new Date(Number(year), Number(month) - 1, Number(day))
  const today = new Date()
  let age = today.getFullYear() - dob.getFullYear()
  const monthDelta = today.getMonth() - dob.getMonth()

  if (monthDelta < 0 || (monthDelta === 0 && today.getDate() < dob.getDate())) {
    age--
  }

  return age < 18
}

export function validateEligibilityForm(formData: EligibilityFormData) {
  const nextErrors: EligibilityFieldErrors = {}

  if (!formData.dateOfBirth.trim()) nextErrors.dateOfBirth = 'Date of birth is required.'
  if (formData.isCitizen === null) {
    nextErrors.isCitizen = 'Please select whether you are a U.S. citizen or permanent resident.'
  }
  if (!formData.gender.trim()) nextErrors.gender = 'Gender is required.'
  if (!formData.ethnicity.trim()) nextErrors.ethnicity = 'Ethnicity is required.'
  if (!formData.educationLevel.trim()) {
    nextErrors.educationLevel = 'Highest education level is required.'
  }

  return nextErrors
}
